// extracted by mini-css-extract-plugin
module.exports = {"BtnDestroy":"_3xlZTUXHXdvD8W3hxB92_s"};